import { render } from "./FormInputText.vue?vue&type=template&id=25407fd6"
import script from "./FormInputText.vue?vue&type=script&lang=js"
export * from "./FormInputText.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "25407fd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25407fd6', script)) {
    api.reload('25407fd6', script)
  }
  
  module.hot.accept("./FormInputText.vue?vue&type=template&id=25407fd6", () => {
    api.rerender('25407fd6', render)
  })

}

script.__file = "resources/js/UI/FormInputText.vue"

export default script